import React, { Component } from 'react';
import { connect } from 'react-redux';
import FotaCarActions from '../../redux/FotaCarRedux';
import FotaCarEditForm from './components/FotaCarForm';
import ContentWrapper from '../../components/ContentWrapper';
import { withTranslation } from 'react-i18next';

class CreateFotaCarPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fotaCar: {
        vin: '',
        iccid: '',
        reference: '',
        firmwareVersion: '',
        bodyType: '',
        year: '',
        configuration: '',
        model: '',
        firmwareStatus: ''
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.fetching !== this.props.fetching && prevProps.fetching && !this.props.error && this.props.fotaCar && this.props.fotaCar.id) {
      this.props.history.goBack();
    }
  }

  onFormSubmit = e => {
    e.preventDefault();
    const { create } = this.props;
    const { fotaCar } = this.state;
    if (fotaCar) {
      create(fotaCar);
    }
  };

  onChange = (name, value) => {
    this.setState({
      fotaCar: { ...this.state.fotaCar, [name]: value },
    });
  };

  render() {
    const { fetching, t } = this.props;

    return (
      <ContentWrapper>
        <h1>{t('Create new FOTA Car')}</h1>
        <form onSubmit={this.onFormSubmit}>
          <FotaCarEditForm
            {...this.state.fotaCar}
            onChange={this.onChange}
            fetching={fetching}
          />
        </form>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = state => ({
  fotaCar: state.fotaCar.data,
  fetching: state.fotaCar.fetching,
  error: state.fotaCar.error,
});

const mapDispatchToProps = dispatch => ({
  create: data => dispatch(FotaCarActions.fotaCarAddRequest(data)),
});

export default withTranslation('fota')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateFotaCarPage));
